import type { FunctionComponent } from 'react';
import type { UseFormRegisterReturn } from 'react-hook-form';

import { useTranslate } from '~/shared/context/use-translate';
import { Textarea } from '~/ui/core/textarea/Textarea';

type VersionNoteInputProps = {
    readonly disabled?: boolean;
    readonly onInput?: () => void;
    readonly register: UseFormRegisterReturn;
};

export const VersionNoteInput: FunctionComponent<VersionNoteInputProps> = ({ disabled = false, onInput, register }) => {
    const translate = useTranslate();

    return (
        <Textarea
            aria-label={translate('pages.job-architecture-v2.version-note.aria-label-input')}
            autoResize={true}
            className="block"
            disabled={disabled}
            maxRows={4}
            placeholder={translate('pages.job-architecture-v2.version-note.placeholder')}
            rows={1}
            variant="default"
            onInput={onInput}
            {...register}
        />
    );
};
